const initialState = {
  fetching: false,
  fetched: false,
  items: [],
  hasMoreItems: false,
  offset: 0,
  limit: 20,
  dashboardSelectedOrg: null,
  error: null,
  nbResult: 0,
  cachedState: null
};
export const dashboardsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "INIT_DASHBOARDES_LIST": {
      return initialState;
    }
    case "RESET_RESOURCES": {
      return { ...initialState };
    }
    case "SET_DASHBOARD_SELECTED_ORG": {
      return {
        ...state,
        dashboardSelectedOrg: action.org
      };
    }
    case "RESET_DASHBOARD_SELECTED_ORG": {
      return { ...state, dashboardSelectedOrg: null };
    }
    case "FETCH_DASHBOARDS_PENDING": {
      return { ...state, fetched: false, fetching: true, items: [], offset: 0 };
    }
    case "SET_FETCHING": {
      return { ...state, fetching: action.payload };
    }
    case "FETCH_DASHBOARDS_FULFILLED": {
      const { data, nbResult } = action.payload.data;

      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: data,
        nbResult: nbResult
      };
    }
    case "FETCH_DASHBOARDS_REJECTED": {
      let error = action.payload;

      if (error && error.response && error.response.status) {
        switch (error.response.status) {
          case 404:
            error = {
              title: error.response.data.title,
              code: 404
            };
            break;
          default:
        }
      }
      return {
        ...state,
        fetching: false,
        error
      };
    }
    case "FETCH_INFINITE_DASHBOARDS_PENDING": {
      return { ...state, fetched: false, fetching: true, hasMoreItems: true };
    }
    case "FETCH_INFINITE_DASHBOARDS_FULFILLED": {
      const { data = [], nbResult } = action.payload.data;

      return {
        ...state,
        fetching: false,
        fetched: true,
        hasMoreItems: data.length >= state.limit,
        offset: state.offset + state.limit,
        error: null,
        items: state.items.concat(data),
        nbResult: nbResult
      };
    }
    case "FETCH_INFINITE_DASHBOARDS_REJECTED": {
      let error = action.payload;

      if (error && error.response && error.response.status) {
        switch (error.response.status) {
          case 404:
            error = {
              title: error.response.data.title,
              code: 404
            };
            break;
          default:
        }
      }
      return {
        ...state,
        fetching: false,
        hasMoreItems: false,
        error
      };
    }
    case "SAVE_DASHBOARD_STATE_TO_CACHE": {
      return {
        ...initialState,
        dashboardSelectedOrg: state.dashboardSelectedOrg,
        cachedState: {
          ...state
        }
      };
    }
    case "RESTORE_DASHBOARD_STATE_FROM_CACHE": {
      return {
        ...state.cachedState,
        dashboardSelectedOrg: state.dashboardSelectedOrg,
        cachedState: null
      };
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/dashboard.js